import { useQuery } from "@tanstack/react-query";
import { absenceKeys } from "../absence.keys";
import { absenceApi } from "../service";

export function useAbsenceDetail(id: number) {
  return useQuery({
    queryKey: absenceKeys.detail(id),
    queryFn: () => absenceApi.getById(id).then((r) => r.data),
    enabled: !!id,
  });
}
